// Read-side DTO/cache sanitation only. Never use this to clear a server credential.
const SECRET_KEYS = new Set([
  'gemini_api_key', 'uazapi_token', 'api_key', 'apiKey', 'access_token',
  'refresh_token', 'webhook_secret', 'instance_token', 'hmac_secret',
]);

export function sanitizeConfigDto<T>(value: T): T {
  if (Array.isArray(value)) return value.map(sanitizeConfigDto) as T;
  if (!value || typeof value !== 'object') return value;
  return Object.fromEntries(Object.entries(value).filter(([key]) => !SECRET_KEYS.has(key))
    .map(([key, item]) => [key, key.startsWith('has_') &&
      (SECRET_KEYS.has(key.slice(4)) || key === 'has_gemini_key')
      ? item === true : sanitizeConfigDto(item)])) as T;
}

export function sanitizeLojaDto<T>(value: T): T & { has_gemini_key: boolean; has_uazapi_token: boolean } {
  const safe = sanitizeConfigDto(value);
  const flags = safe as { has_gemini_key?: unknown; has_uazapi_token?: unknown };
  return { ...safe, has_gemini_key: flags?.has_gemini_key === true,
    has_uazapi_token: flags?.has_uazapi_token === true };
}

// Store editing has no credential fields. Omit DTO flags/config entirely rather
// than echoing a hidden secret as null, blank text or a mask.
export function lojaUpdatePayload(updates: Record<string, unknown>) {
  const allowed = ['nome', 'slug', 'endereco', 'telefone', 'email', 'ativa', 'assinatura_atendente_ativa'];
  return Object.fromEntries(allowed.filter(key => updates[key] !== undefined)
    .map(key => [key, updates[key]]));
}
